import { VariablesManager } from '@carboncopyco/editor-ui';
import { isImageVariable } from '@carboncopyco/editor-utils';
import { IFindAndReplaceRuleType } from '@carboncopyco/types';
import { memo, useMemo } from 'react';
import { useEditor, useEditorVariables } from '../context/EditorSdkProvider';
import { useEditorTool } from '../hooks/useEditorTool';

export const VariablesManagerTool = memo(() => {
  const editorSdk = useEditor();
  const {
    variables,
    createVariable,
    editVariable,
    deleteVariable,
    reorderVariables,
  } = useEditorVariables();
  const { isOpen, close } = useEditorTool('variable');

  const modifiedVariables = useMemo(() => {
    const { filesServiceDomain } = editorSdk;
    return variables.map((variable) => {
      if (isImageVariable(variable)) {
        return {
          ...variable,
          value: `${filesServiceDomain}${variable.value}`,
        };
      }

      return variable;
    });
  }, [editorSdk, variables]);

  return (
    <VariablesManager
      isOpen={isOpen}
      onClose={close}
      variables={modifiedVariables}
      createVariable={createVariable}
      editVariable={editVariable}
      deleteVariable={deleteVariable}
      reorderVariables={reorderVariables}
      onUseVariable={async (variable) => {
        if (isImageVariable(variable)) {
          editorSdk.startFindAndReplaceMode({
            ruleType: IFindAndReplaceRuleType.replaceImageWithVariable,
            variableId: variable.variableId,
          });
        }
      }}
      onLearnMoreClick={editorSdk.openUrlLink}
    />
  );
});

VariablesManagerTool.displayName = 'VariablesManagerTool';
